import {combineEpics} from "redux-observable";

export const AppEpics = combineEpics();
